import React, { useState } from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Navbar,
  Nav,
  Container,
  NavItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { logout as logoutAction } from "actions/public";

function AdminNavbar({ theme, sidenavOpen, toggleSidenav }) {
  const navigate = useNavigate();
  const userName = JSON.parse(localStorage.getItem("p"));
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = async () => {
    try {
      setIsLoggingOut(true);

      const response = await logoutAction();

      if (response?.status === "SUCCESS") {
        localStorage.clear();
        navigate("/auth/login");
      } else {
        localStorage.clear();
        navigate("/auth/login");
      }
    } catch (error) {
      localStorage.clear();
      navigate("/auth/login");
    } finally {
      setIsLoggingOut(false);
    }
  };

  const organizationName = JSON.parse(localStorage.getItem("p"));
  const capitalized = organizationName?.organizationName
    ? organizationName?.organizationName.charAt(0).toUpperCase() +
      organizationName?.organizationName.slice(1)
    : "";
  return (
    <>
      {isLoggingOut && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin logout-spinner" />
            <h3 className="logout-text">Logging Out...</h3>
          </div>
        </div>
      )}
      <Navbar
        className={classnames(
          "navbar-top navbar-expand border-bottom navbar-dark"
        )}
      >
        <Container fluid>
          <span className="text-white h3 d-none d-sm-block ">
            {capitalized}
          </span>
          <Collapse navbar isOpen={true} style={{ justifyContent: "flex-end" }}>
            <Nav className="align-items-center ml-md-auto " navbar>
              <NavItem className="d-xl-none">
                <div
                  className={classnames(
                    "pr-3 sidenav-toggler mt--2",
                    { active: sidenavOpen },
                    { "sidenav-toggler-dark": theme === "dark" }
                  )}
                  onClick={toggleSidenav}
                >
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line-white" />
                    <i className="sidenav-toggler-line-white" />
                    <i className="sidenav-toggler-line-white" />
                  </div>
                </div>
              </NavItem>
              <span className="text-white h3 d-xl-none">{capitalized}</span>
            </Nav>
            <Nav className="align-items-center ml-auto ml-md-0" navbar>
              <UncontrolledDropdown nav>
                <DropdownToggle className="nav-link pr-0" color="" tag="a">
                  <Media className="align-items-center">
                    <Media className="ml-2 d-flex d-lg-block align-items-center mt--3">
                      <span
                        className="mb-0 text-medium font-weight-bold"
                        style={{ cursor: "pointer" }}
                      >
                        {userName?.name === ""
                          ? userName?.Email
                          : userName?.name}
                      </span>
                      <span
                        className="btn-inner--icon ml-2"
                        style={{ cursor: "pointer" }}
                      >
                        <i className="fa fa-ellipsis-v" />
                      </span>
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu right>
                  {/* <DropdownItem onClick={(e) => navigate("/a/user/profile")}>
                    <i className="ni ni-single-02" />
                    <span>Profile</span>
                  </DropdownItem> */}

                  <DropdownItem onClick={() => logout()}>
                    <i className="fa fa-sign-out" />
                    <span>Logout</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

AdminNavbar.defaultProps = {
  toggleSidenav: () => {},
  sidenavOpen: false,
  theme: "dark",
};
AdminNavbar.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(["dark", "light"]),
};

export default AdminNavbar;
